import {
    createStore, applyMiddleware, compose, combineReducers,
} from 'redux';
import thunk from 'redux-thunk';
import EntriesListReducer from '../Reducers/EntriesListReducer'
import AuthReducer from '../Reducers/AuthReducer';


const composeEnhancers = process.env.NODE_ENV === 'development' ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : compose;

const rootReducer = combineReducers({
    entries: EntriesListReducer,
    auth: AuthReducer,
});

export const Store = createStore(rootReducer, composeEnhancers(
    applyMiddleware(thunk),
));
